import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { StepPropTypes } from '../../constants/propTypes';

import {
  ActionPortal,
  Checkbox,
  DefaultActionButtons,
  DefaultContainer,
  Form,
  FormGroup,
  Icon,
  Radio,
  Step,
  Text,
} from 'components';

import {
  listAvailableBillingDueDays
} from '../../services/api.js';

import { Gray, Orange, Purple } from 'constants/colors';

export default function ExpirationDate(props) {
  const {
    theme, onSubmit, onCancel, initialValues = {},
  } = props;

  const {
    control, errors, formState, handleSubmit, register,
  } = useForm({
    mode: 'all',
    defaultValues: {
      ...initialValues,
      acceptTerms: initialValues?.acceptTerms || false,
      expirationDate: initialValues?.expirationDate || null,
    },
  });

  const { isValid } = formState;

  const { basicInfo } = useSelector((state) => state.subscription);
  const [RadioOptions, setRadioOptions] = useState([<div />]);

  useEffect(() => {
    (async () => {
      const {
        address: {
          matrixstate: {
            value: billing_address_state = '*'
          } = {},
        } = {}
      } = basicInfo || {};
      const {
        available_billing_due_days
      } = await listAvailableBillingDueDays({
        billing_address_state,
        contele_product_id: 'cgv_tracker_device_unit',
      });

      const radio_options = available_billing_due_days.map((due_day) => {
        const due_day_with_pad_start = due_day.toString().padStart(2, "0");

        return (
          <Radio
            type="radio"
            name="expirationDate"
            value={due_day}
            id={"expirationDate-" + due_day}
            invalid={!!errors.expirationDate}
            innerRef={register({ required: true })}
            label={"Dia " + due_day_with_pad_start}
          />
        );
      });

      setRadioOptions(radio_options);
    })();
  }, []);

  const submitForm = (e) => {
    e.preventDefault();
    handleSubmit(onSubmit)();
  }

  return (
    <div style={{ height: '100%', backgroundColor: Gray[200], overflow: 'hidden' }}>
      <Step
        headerTitle="Data de Vencimento"
      >
        <DefaultContainer>
          <Form
            style={{ padding: 0 }}
            onKeyPress={e => e.key === 'Enter' && submitForm(e)}
          >
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                backgroundColor: Gray[100],
                borderRadius: '5px',
                padding: '20px',
                border: `1px solid ${Gray[250]}`,
              }}>
                <Text
                  color={Gray[500]}
                  fontSize="16px"
                  fontWeight="600"
                >
                  Qual o melhor dia de vencimento para a fatura mensal?
                </Text>
                <FormGroup
                  tag="fieldset"
                  style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
                >
                  {RadioOptions}
                </FormGroup>
              </div>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                backgroundColor: Gray[100],
                borderRadius: '5px',
                padding: '20px',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Icon
                    color={Gray[400]}
                    icon="exclamationCircle"
                    style={{ width: '16px', height: '16px' }}
                  />
                  <Text
                    color={Gray[400]}
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight="700"
                  >
                    Cobrança
                  </Text>
                </div>
                <Text
                  color={Gray[400]}
                  fontSize="14px"
                  lineHeight="19px"
                  fontWeight="400"
                >
                  A cobrança da locação dos equipamentos se inicia a partir da entrega dos mesmos. Dependendo da data escolhida a primeira fatura pode ser cobrado de forma proporcional (pro rata).
                </Text>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    type="checkbox"
                    control={control}
                    name="acceptTerms"
                    id="acceptTerms"
                    innerRef={register({
                      required: true,
                    })}
                  />
                  <Text
                    color={Gray[400]}
                    fontSize="14px"
                    lineHeight="19px"
                    fontWeight="400"
                    textAlign="center"
                  >
                    Sim, estou ciente.
                  </Text>
                </div>
              </div>
              
              {!isValid && (
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  backgroundColor: Orange[100],
                  borderRadius: '5px',
                  padding: '20px',
                }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Icon
                      color={Orange[400]}
                      icon="exclamationTriangle"
                      style={{ width: '16px', height: '16px' }}
                    />
                    <Text
                      color={Orange[400]}
                      fontSize="16px"
                      lineHeight="19px"
                      fontWeight="700"
                    >
                      Requisitos para Prosseguir
                    </Text>
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                  }}
                  >
                    {!formState.dirtyFields.expirationDate && (
                      <Text
                        color={Orange[400]}
                        fontSize="14px"
                        lineHeight="19px"
                        fontWeight="400"
                      >
                        • Você precisa selecionar um dia de vencimento para a fatura
                      </Text>
                    )}
                    {!formState.dirtyFields.acceptTerms && (
                      <Text
                        color={Orange[400]}
                        fontSize="14px"
                        lineHeight="19px"
                        fontWeight="400"
                      >
                        • É necessário aceitar os termos sobre a cobrança
                      </Text>
                    )}
                  </div>
                </div>
              )}
            </div>

            <ActionPortal>
              <DefaultActionButtons
                theme={theme}
                isValid={isValid}
                backButtonStyle={{
                  iconPosition: 'left',
                  border: 'none',
                  customBackgroundColor: 'transparent',
                  customIconColor: Gray[400],
                  customTextColor: Gray[400],
                  title: 'Passo Anterior',
                }}
                nextButtonStyle={{
                  customBackgroundColor: Purple[500],
                  customIconColor: Gray[100],
                  customTextColor: Gray[100],
                  title: 'Próximo Passo',
                }}
                onCancel={onCancel}
                onSubmit={() => handleSubmit(onSubmit)()}
              />
            </ActionPortal>
          </Form>
        </DefaultContainer>
      </Step>
    </div>
  );
}

ExpirationDate.propTypes = StepPropTypes;
